'use client'

import { Box } from '@chakra-ui/react'
import { keyframes } from '@emotion/react'

import Container from 'app/components/shared/Container'

import TestimonialCard from './TestimonialCard'
import { TestimonialTitle } from './TestimonialTitle'
import { Testimonial } from '.'

type Props = {
  heading: string
  testimonials: Testimonial[]
}

// marquee animation
const marquee = keyframes`
  0% { transform: translateX(0%); }
  100% { transform: translateX(-50%); }
`

const marqueeReverse = keyframes`
  0% { transform: translateX(-50%); }
  100% { transform: translateX(0%); }
`

const TestimonialsNew = ({ heading, testimonials }: Props): JSX.Element => {
  // Duplicate testimonials
  const loopTestimonials = [...testimonials, ...testimonials]

  return (
    <Box marginTop={{ base: '72px', lg: '160px' }} overflow="hidden">
      <Container>
        <TestimonialTitle
          style={{ marginBottom: '40px' }}
          subtitle="Vi har 4.5 av 5 i gjennomsnittlig vurdering"
          title={heading}
        />
        <TestimonialCard testimonials={loopTestimonials} animationType={marquee} />
        <TestimonialCard testimonials={loopTestimonials} animationType={marqueeReverse} />
      </Container>
    </Box>
  )
}

export default TestimonialsNew
